import React, { useState } from 'react';
import { Card, Button, Typography, Space, Row, Col } from 'antd';
import { DeleteOutlined, EditOutlined } from '@ant-design/icons';

const { Text, Link } = Typography;

const EditProductCard = ({
  productName,
  category,
  lastUpdated,
  productLink,
  productImage,
  onDelete,
  onEdit,
}) => {
  const [isHovered, setIsHovered] = useState(false);

  const imageContainerStyle = {
    position: 'relative',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '200px', // Adjust as needed
    overflow: 'hidden',
    cursor: 'pointer',
  };

  const productImageStyle = {
    maxWidth: '100%',
    maxHeight: '100%',
    objectFit: 'contain',
    transition: 'transform 0.3s ease',
    transform: isHovered ? 'scale(1.05)' : 'scale(1)',
  };

  const buttonStyle = {
    position: 'absolute',
    opacity: isHovered ? 1 : 0,
    transition: 'opacity 0.3s ease',
  };

  const deleteButtonStyle = {
    ...buttonStyle,
    top: '10px',
    right: '10px',
  };

  const editButtonStyle = {
    ...buttonStyle,
    top: '10px',
    right: '55px', // Position to the left of delete button
  };

  return (
    <Col xs={24} sm={12} md={8} lg={6}>
      <Card
        hoverable
        style={{ width: '100%', marginBottom: '10px' }}
        cover={
          <div
            style={imageContainerStyle}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
          >
            {productImage && (
              <img
                alt={productName}
                src={productImage}
                style={productImageStyle}
              />
            )}
            <Button
              type="primary"
              shape="circle"
              icon={<EditOutlined />}
              style={editButtonStyle}
              onClick={onEdit}
            />
            <Button
              type="primary"
              danger
              shape="circle"
              icon={<DeleteOutlined />}
              style={deleteButtonStyle}
              onClick={onDelete}
            />
          </div>
        }
      >
        <Space direction="vertical" size="small" style={{ width: '100%' }}>
          <Text strong style={{ fontSize: '16px' }}>
            {productName}
          </Text>
          <Text type="secondary" style={{ fontSize: '14px' }}>
            {category}
          </Text>
      
          <Link href={productLink} target="_blank" rel="noopener noreferrer">
            {productLink}
          </Link>
        </Space>
      </Card>
    </Col>
  );
};

export default EditProductCard;
